import React from 'react';
import { CheckCircleFill, Truck } from 'react-bootstrap-icons';
import { useLocale } from '../../i18n/LocaleContext';
import './GamePrizes.scss';

/**
 * Contract v2: a won product goes into the winner's cart for FREE and its
 * shipping is MANDATORILY free — the brand pays it. Said plainly before
 * scheduling and on the wheel's card.
 */
export default function FreeNotice({ compact = false }) {
  const { t } = useLocale();
  return (
    <div className={`wheel-free${compact ? ' is-compact' : ''}`} role="note">
      <span className="wheel-free__icon" aria-hidden="true"><Truck size={compact ? 14 : 16} /></span>
      <span>
        <strong>{t('wheel.free.title')}</strong> {t('wheel.free.text')}
      </span>
    </div>
  );
}

/** "Tudomásul veszem…" — the API requires it (freeShippingAccepted: true) whenever products are given away. */
export function FreeAccept({ checked, onChange, disabled, invalid }) {
  const { t } = useLocale();
  return (
    <label className={`wheel-rules wheel-free-accept${checked ? ' is-on' : ''}${invalid ? ' is-invalid' : ''}`}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} disabled={disabled} />
      <span className="wheel-rules__box" aria-hidden="true">{checked && <CheckCircleFill size={16} />}</span>
      <span className="wheel-rules__text">
        <strong>{t('wheel.free.accept')}</strong>
      </span>
    </label>
  );
}
